<template>
    <div class="context common_add_view">
        <div class="header">
            <div class="search">
                <el-page-header @back="back" :content="viewTitle">
                </el-page-header>
            </div>
        </div>
        <div class="main_box">
            <el-form :model="form" :rules="rules" ref="form" label-width="120px">
                <el-form-item label="事件类型：" prop="event_name">
                    <el-select v-model="form.event_name" class="width_220">
                        <el-option v-for="(item,index) in points_task_event_list"
                                   :label="item"
                                   :value="item"
                                   :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="获取次数：" prop="repeat">
                    <el-radio-group v-model="form.repeat" @input="changeRepeat">
                        <el-radio :label="1">仅一次</el-radio>
                        <el-radio :label="2">可重复多次</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="最高限制："
                              prop="maximum_type"
                              v-if="form.repeat == 2">
                    <el-radio-group v-model="form.maximum_type" @change="changeMaxType">
                        <!--<el-radio :label="1">不限</el-radio>-->
                        <el-radio :label="2">累计最高分</el-radio>
                        <el-radio :label="3">周期累计最高分</el-radio>
                    </el-radio-group>
                    <span style="padding-left: 30px; color: #E6A23C">（注：该分数请设置为每次积分数的整数倍）</span>
                    <div v-if="form.maximum_type != 1">
                        <el-input-number v-model="form.maximum"
                                         controls-position="right"
                                         :min="1"
                                         :max="calcMax"></el-input-number>
                    </div>
                </el-form-item>
                <el-form-item label="每次积分数：" prop="score">
                    <el-input-number v-model="form.score"
                                     controls-position="right"
                                     :min="1" :max="100"></el-input-number>
                </el-form-item>
                <el-form-item label="任务描述：">
                    <el-input type="textarea"
                              class="width_400"
                              v-model="form.wording"
                              :autosize="{ minRows: 2}"
                              placeholder="请输入任务描述"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitNow">提交</el-button>
                </el-form-item>
            </el-form>

        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"
    import {clone} from "@/global/utils";

    export default {
        name: "addView",
        data() {
            return {
                viewTitle: '添加规则',

                form: {
                    event_name: '',
                    repeat: 1,
                    maximum_type: 2,
                    maximum: 1,
                    score: 1,
                    wording: '',
                },
                rules: {
                    event_name: [{required: true, message: '请选择事件类型', target: 'blur'}],

                },

                eventList: [],

            }
        },
        computed: {
            ...mapState('manageData', {
                jifen_rule_data: 'jifen_rule_data'
            }),
            ...mapState('comInformationData', {
                points_task_event_list: 'points_task_event_list'
            }),
            calcMax() {
                let nums = this.form.maximum_type == 2 ? 500 : 200;
                return nums
            }
        },
        mounted() {
            console.log(this.jifen_rule_data, '20');
            this.viewTitle = this.jifen_rule_data ? '修改规则' : '添加规则';
            if (this.jifen_rule_data) {
                this.form = clone(this.jifen_rule_data)
            } else {
                this.form = {
                    event_name: '',
                    repeat: 1,
                    maximum_type: 2,
                    maximum: 1,
                    score: 1,
                    wording: '',
                }
            }
        },
        methods: {
            back() {
                this.$emit('changeTopTab', 'tableView')
            },

            changeRepeat() {
                this.form.maximum_type = 2;
                this.form.maximum = 1;
            },
            changeMaxType(e) {
                if(e === 3) {
                    if(this.form.maximum > 200) {
                        this.form.maximum = 200
                    }
                }
            },

            submitNow() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        if (this.jifen_rule_data) {
                            this.submitEdit()
                        } else {
                            this.submitAdd()
                        }
                    }
                })
            },
            submitAdd() {
                let params = {
                    ...this.form
                };
                this.httpPost('/points/task', params).then(res => {
                    this.$message.success('添加成功！');
                    this.back()
                })
            },
            submitEdit() {
                let params = {
                    ...this.form
                };
                this.httpPut(`/points/task/${params.task_id}`, params).then(res => {
                    this.$message.success('修改成功！');
                    this.back()
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>